import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  padding: 0;
`;

// etiqueta colorida da situacao na listagem (cores em util.js, CORES_SITUACAO)
export const SituacaoTag = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  background-color: ${props => props.cor};
`;
